import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { CompanyAuthProvider } from './contexts/CompanyAuthContext'
import { LoadingProvider, useLoading } from './contexts/LoadingContext'
import { setupLoadingInterceptors } from './utils/api'
import GlobalLoadingOverlay from './components/common/GlobalLoadingOverlay'
import CompanyLoginPage from './pages/company/CompanyLoginPage'
import CompanyDashboardPage from './pages/company/CompanyDashboardPage'
import CompanyActivationPage from './pages/company/CompanyActivationPage'
import ResetPasswordPage from './pages/company/ResetPasswordPage'
import CreatePasswordPage from './pages/company/CreatePasswordPage'
import './index.css'
import 'react-toastify/dist/ReactToastify.css'

// Wires the shared axios instance (src/utils/api.js) to LoadingContext, so every
// request made through it shows GlobalLoadingOverlay automatically unless the
// call explicitly opts out with `{ silentLoading: true }`.
const ApiLoadingBridge = () => {
  const { startLoading, stopLoading } = useLoading()
  useEffect(() => {
    setupLoadingInterceptors(startLoading, stopLoading)
  }, [startLoading, stopLoading])
  return null
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LoadingProvider>
      <ApiLoadingBridge />
      <CompanyAuthProvider>
        <GlobalLoadingOverlay />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<CompanyLoginPage />} />
            <Route path="/dashboard/*" element={<CompanyDashboardPage />} />
            <Route path="/activate" element={<CompanyActivationPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/create-password" element={<CreatePasswordPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </CompanyAuthProvider>
    </LoadingProvider>
  </React.StrictMode>
)
